import React from "react";

export const Section = ({ title, eyebrow, right, children }) => (
  <section className="mt-8">
    <div className="flex items-end justify-between mb-4 gap-4 flex-wrap">
      <div>
        {eyebrow && (
          <div className="text-[10px] uppercase tracking-[0.3em] text-myb-500 mb-1 font-semibold">{eyebrow}</div>
        )}
        <h2 className="font-display text-2xl lg:text-3xl tracking-tight font-light text-foreground">{title}</h2>
      </div>
      {right}
    </div>
    {children}
  </section>
);

export const PageHeader = ({ eyebrow, title, subtitle, right }) => (
  <header className="flex flex-wrap items-end justify-between gap-4 mb-6">
    <div>
      {eyebrow && (
        <div className="text-[10px] uppercase tracking-[0.3em] text-myb-500 mb-2 font-semibold">{eyebrow}</div>
      )}
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-light text-foreground">{title}</h1>
      {subtitle && <p className="text-muted-foreground mt-3 max-w-2xl text-sm">{subtitle}</p>}
    </div>
    {right}
  </header>
);

export const Card = ({ title, right, children, className = "", testId }) => (
  <div
    data-testid={testId}
    className={`print-card bg-white border hairline rounded-sm p-4 sm:p-5 md:p-6 relative overflow-hidden animate-fade-up shadow-[0_2px_12px_rgba(13,56,128,0.05)] ${className}`}
  >
    {(title || right) && (
      <div className="flex items-center justify-between mb-4">
        <div className="text-[10px] uppercase tracking-[0.25em] text-myb-500 font-semibold">{title}</div>
        {right}
      </div>
    )}
    {children}
  </div>
);
